export default {"src":"/_next/static/media/AEP.881612df.svg","height":18,"width":18};